module.exports = __webpack_public_path__ + "static/media/cardPacoteBgLight.11e67bbc.png";